import { useState } from 'react';
import { logger } from '@teko/log';
import { useLoading } from '@teko/ds-desktop';

const useProfile = ({
  userService
}) => {
  const [loadingProfile, setLoadingProfile] = useLoading("useProfile");
  const [customerTypes, setCustomerTypes] = useState();
  const fetchCustomerTypes = async (params = { pageSize: 50 }) => {
    var _a;
    try {
      setLoadingProfile(true);
      const listCustomerTypes = await userService.customerTypes(params);
      const customerTypesArray = ((_a = listCustomerTypes == null ? void 0 : listCustomerTypes.result) == null ? void 0 : _a.customerTypes) || [];
      setCustomerTypes(customerTypesArray.map((item) => ({
        value: item.id,
        text: item.display
      })));
    } catch (e) {
      logger.error(e);
      setCustomerTypes([]);
    } finally {
      setLoadingProfile(false);
    }
  };
  return {
    loadingProfile,
    customerTypes,
    fetchCustomerTypes
  };
};

export { useProfile };
